"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TableData = function TableData(_ref) {
  var data = _ref.data,
      selected = _ref.selected,
      id = _ref.id,
      _onClick = _ref.onClick,
      withCheckbox = _ref.withCheckbox,
      updateSelectedRows = _ref.updateSelectedRows;
  var rowClass = 'data-table__row';
  if (selected) rowClass += ' data-table__row--selected';
  if (_onClick) rowClass += ' data-table__row--clickable';

  var handleClick = function handleClick(event) {
    return event.stopPropagation();
  };

  return _react.default.createElement("tr", {
    className: rowClass,
    onClick: function onClick() {
      return _onClick && _onClick(id);
    }
  }, withCheckbox && _react.default.createElement("td", {
    key: id,
    className: "data-table__col data-table__col--checkbox",
    onClick: handleClick
  }, _react.default.createElement(_Checkbox.default, {
    onChange: function onChange() {
      return updateSelectedRows(id);
    },
    checked: selected
  })), Object.keys(data).map(function (key, index) {
    if (key === 'id') return null;
    return _react.default.createElement("td", {
      key: index,
      className: "data-table__col",
      onClick: function onClick(event) {
        return data[key].props.onClick ? handleClick(event) : null;
      }
    }, data[key].component || data[key]);
  }));
};

TableData.propTypes = {
  data: _propTypes.default.object,
  selected: _propTypes.default.bool,
  id: _propTypes.default.number,
  withCheckbox: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  updateSelectedRows: _propTypes.default.func
};
var _default = TableData;
exports.default = _default;